import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import LdsModal from './index.jsx';
import { LdsModalContext } from './LdsModalProvider.jsx';

export default function LdsAudienceAffirmationModal({
  defaultOpen = true,
  modalId = 'hcpModal',
  heading = '',
  cookieName = 'lds_hcp',
  children,
}) {
  const {
    openModal,
    closeModal,
    activeModal,
    isAudienceAffirmed,
  } = useContext(LdsModalContext);

  useEffect(() => {
    if (defaultOpen && defaultOpen !== 'false') {
      if (!isAudienceAffirmed(cookieName)) openModal(modalId);
    }
  }, [modalId, defaultOpen, cookieName]);

  return (
    <LdsModal
      modalId={modalId}
      open={activeModal === modalId}
      closeModal={closeModal}
      heading={heading}
      persistent
    >
      {children}
    </LdsModal>
  );
}

LdsModal.propTypes = {
  defaultOpen: PropTypes.bool,
  modalId: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
};
